import React from "react"

const JoinCommunity = () => {
  return (
    <section id="join-community">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <h1>Join community right now</h1>
            <button className="community-btn btn">Join community</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default JoinCommunity
